import React, { Component } from 'react';
import { Table } from 'antd';
import moment from 'moment';

import baseData from '@util/base';
import util from '@util/index';

class TableIncome extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getType = type => {
    const index = baseData.attachmentType.findIndex(item => +item.key === +type);
    return index > -1 ? baseData.attachmentType[index].name : '';
  };

  handleDelete = uuid => {
    this.props.handleChooseData(this.props.dataSource.filter(item => item.uuid !== uuid));
  };

  columns = () => {
    const { disabled } = this.props;
    const columns = [
      {
        title: '日期',
        dataIndex: 'date',
        width: 120,
        render: (text, record, index) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '金额',
        dataIndex: 'money',
        width: 100,
        render: text => {
          return <span>{text > 0 ? util.numberFormat(text) : 0}</span>;
        },
      },
      {
        title: '类型',
        dataIndex: 'target',
        width: 80,
        render: (text, record) => <span>{text === 0 ? '支出' : '收入'}</span>,
      },
      {
        title: '摘要',
        dataIndex: 'remark',
        width: 200,
      },
    ];
    return disabled
      ? columns
      : [
          ...columns,
          {
            title: '操作',
            dataIndex: 'done',
            render: (text, record) => {
              return disabled ? null : <a onClick={() => this.handleDelete(record.uuid)}>删除</a>;
            },
          },
        ];
  };

  render() {
    const { dataSource } = this.props;
    return (
      <Table
        columns={this.columns()}
        dataSource={dataSource}
        pagination={false}
        rowKey="uuid"
        onChange={this.handleTableChange}
      />
    );
  }
}

export default TableIncome;



// WEBPACK FOOTER //
// ./src/components/incubator/comm/TableIncome.js